import { AlertTriangle, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/hooks/useTranslation'
import { cn } from '@/lib/utils'

export interface TranscriptAudioQualityNudgeProps {
	visible: boolean
	onDismiss: () => void
	/** When false, the slot still reserves space but content is invisible (stable layout) */
	className?: string
}

export function TranscriptAudioQualityNudge({
	visible,
	onDismiss,
	className,
}: TranscriptAudioQualityNudgeProps) {
	const { t } = useTranslation()

	return (
		<div
			className={cn(
				'mb-4 flex min-h-14 items-stretch rounded-lg border border-amber-500/35 bg-amber-500/10 text-amber-950 dark:border-amber-400/40 dark:bg-amber-500/15 dark:text-amber-50',
				!visible && 'border-transparent bg-transparent dark:border-transparent dark:bg-transparent',
				className
			)}
			role="status"
			aria-live="polite"
			aria-hidden={!visible}
		>
			<div
				className={cn(
					'flex w-full items-start gap-3 px-3 py-3',
					!visible && 'pointer-events-none invisible'
				)}
			>
				<AlertTriangle className="size-5 shrink-0 text-amber-600 dark:text-amber-300" aria-hidden />
				<p className="min-w-0 flex-1 text-sm leading-snug">
					{t('pages.projectDetail.transcript.audioQualityWarning')}
				</p>
				<Button
					type="button"
					variant="ghost"
					size="icon-sm"
					className="shrink-0 text-amber-900 hover:bg-amber-500/20 dark:text-amber-100"
					aria-label={t('pages.projectDetail.transcript.dismissAudioQualityWarning')}
					onClick={onDismiss}
				>
					<X className="size-4" aria-hidden />
				</Button>
			</div>
		</div>
	)
}
